import { useProjectList } from '~/requests/projects/useProjectList';
import PopupMenu from './PopupMenu';
import { Menu } from 'semantic-ui-react';

import { Link } from 'react-router-dom';
import { PopupMenuProps } from './types';
import { Project } from '~/types/project';
import { PopupMenuEmptyMessage } from './PopupMenuEmptyMessage';

export default function ProjectsPopupMenu ({ trigger, onClose }: PopupMenuProps) {
  const { data: projects, status } = useProjectList();
  const activeProjects = projects?.filter((project: Project) => !project?.isArchived && !project?.portfolioIsArchived);

  return (
    <PopupMenu trigger={trigger} onClose={onClose} isLoading={status === 'loading'}>
      {activeProjects?.length === 0 ? 
        <PopupMenuEmptyMessage message='No projects to display' />
        : activeProjects?.map((project: Project) => (
          <Menu.Item
            key={project.id}
            as={Link}
            to={`/project/${project.id}`}
            onClick={() => onClose()}
            className="legacy-popup-menu-item"
          >
            {project.name}
          </Menu.Item>
      ))}
    </PopupMenu>
  );
}